import axiosPost from "./axiosPost";

export const RNHAreaDel = async (credentials, data) => {
    const body = {
        service: "RNHAreaDel",
        params: {
            rnhAreaId: data?.id,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
